<template>
  <StyleQuizLayout
    :title="$t('project_details.style_quiz.select_your_style')"
    :subtitle="
      $t('project_details.style_quiz.select_your_style_from', {
        number: styles?.length ?? '',
      })
    "
    :loading="loading"
    :data="styles"
    @onBack="emit('onBack')"
    @onNext="onSubmit"
    :multiple="false"
  />
</template>

<script setup>
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import axios from "axios";
import { inject, onMounted, ref } from "vue";
import AlertHelper from "@/helpsers/alert.helper";
import StyleQuizLayout from "./StyleQuizLayout.vue";

const alert = inject("alert");
const emit = defineEmits(["onBack", "onDone"]);
const styles = ref(null);

const loading = ref(true);
onMounted(() => {
  axios
    .get(ApiHelper.getStyleQuizPhotosUrl() + "?stage=0", {
      headers: authHelper.authHeader(),
    })
    .then((res) => (styles.value = res.data))
    .catch((e) => {
      AlertHelper.show(
        alert,
        "Błąd wczytywania strony",
        e.response?.data?.message,
        "error"
      );
    })
    .finally(() => (loading.value = false));
});

const props = defineProps(["projectId"]);

const emitter = inject("emitter");

/**
 *
 * @param Array<{id, name, imagePath, tags}> result
 */
function onSubmit(result) {
  const [item] = result;
  const id = item.id;
  axios
    .post(
      ApiHelper.saveStyle(props.projectId),
      { imagesIds: [id] },
      {
        headers: authHelper.authHeader(),
      }
    )
    .then((res) => {
      emitter.emit("styleQuizCompleted", res.data);
      emit("onDone");
    })
    .catch((e) => {
      AlertHelper.show(
        alert,
        "Błąd wczytywania strony",
        e.response?.data?.message,
        "error"
      );
    });
}
</script>

<style scoped lang="scss"></style>
